import React from "react";
import { Link } from "react-router-dom";
import { productUrl } from "@/config/siteUrls";

const COL_METHODOLOGY = [
  { label: "Overview", to: "/methodology" },
  { label: "Why Adaptive Physiology?", to: "/methodology/why" },
  { label: "The Framework", to: "/methodology/framework" },
  { label: "The Science", to: "/methodology/science" },
  { label: "How It Works", to: "/methodology/how-it-works" },
  { label: "Outcomes", to: "/methodology/outcomes" },
];

const COL_ENGAGE = [
  { label: "Start here", to: "/apply" },
  { label: "Adaptive Assessment™", to: "/assessment", product: true },
  { label: "APOS Companion — coming soon", to: "/app", product: true },
  { label: "Applications", to: "/applications" },
  { label: "Programs", to: "/programs" },
  { label: "Scientific Foundations", to: "/foundations" },
];

const COL_ORG = [
  { label: "About Adaptive Physiology", to: "/about/origin" },
  { label: "About FORR Health", to: "/about/origin#forr-health" },
  {
    label: "Professional Consultation",
    to: "/programs/professional-consultation",
  },
  { label: "Contact", to: "/apply" },
];

const LinkCol = ({ title, links }) => (
  <div>
    <div className="text-[11px] font-semibold uppercase tracking-[0.28em] forr-text-mute mb-5">
      {title}
    </div>
    <ul className="space-y-3">
      {links.map((l) => (
        <li key={l.label}>
          {l.product ? (
            <a
              href={productUrl(l.to)}
              className="text-sm forr-text-soft hover:forr-text-teal-deep transition-colors"
            >
              {l.label}
            </a>
          ) : (
            <Link
              to={l.to}
              className="text-sm forr-text-soft hover:forr-text-teal-deep transition-colors"
            >
              {l.label}
            </Link>
          )}
        </li>
      ))}
    </ul>
  </div>
);

const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t py-20 forr-canvas-warm"
      style={{ borderColor: "var(--forr-line)" }}
    >
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16">
        <div className="grid grid-cols-12 gap-10">
          <div className="col-span-12 md:col-span-4 lg:col-span-4">
            <Link to="/" className="flex items-center gap-2.5">
              <div className="relative w-7 h-7">
                <div
                  className="absolute inset-[2px] rounded-full border"
                  style={{ borderColor: "var(--forr-teal)" }}
                />
                <div
                  className="absolute inset-[7px] rounded-full"
                  style={{ backgroundColor: "var(--forr-teal)" }}
                />
              </div>
              <span className="flex flex-col leading-none">
                <span className="font-display forr-text-ink text-sm font-medium tracking-tight">
                  Adaptive Physiology
                  <span className="forr-text-teal-deep align-super text-[8px] ml-0.5">
                    ™
                  </span>
                </span>
                <span className="text-[10px] tracking-[0.22em] uppercase forr-text-mute mt-1">
                  A methodology by FORR Health
                </span>
              </span>
            </Link>
            <p className="mt-8 text-sm forr-text-soft font-light leading-relaxed max-w-xs">
              A science-informed methodology for changing behavior by retraining
              the physiological state that produces it.
            </p>
          </div>

          <div className="col-span-6 md:col-span-2 lg:col-span-3">
            <LinkCol title="Methodology" links={COL_METHODOLOGY} />
          </div>
          <div className="col-span-6 md:col-span-3 lg:col-span-2">
            <LinkCol title="Engage" links={COL_ENGAGE} />
          </div>
          <div className="col-span-12 md:col-span-3 lg:col-span-3">
            <LinkCol title="Organization" links={COL_ORG} />
          </div>
        </div>

        <div
          className="mt-16 pt-8 border-t flex flex-col md:flex-row items-start md:items-center justify-between gap-4"
          style={{ borderColor: "var(--forr-line)" }}
        >
          <div
            data-testid="footer-copyright"
            className="text-xs forr-text-mute tracking-wide"
          >
            © {new Date().getFullYear()} FORR Health · Adaptive Physiology™ is a
            methodology developed by FORR Health.
          </div>
          <div className="flex gap-6 text-xs forr-text-mute">
            <Link to="/privacy" className="hover:forr-text-teal-deep transition-colors">Privacy</Link>
            <Link to="/terms" className="hover:forr-text-teal-deep transition-colors">Terms</Link>
            <span>Accessibility</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
